module.exports = "/static/assets/f4d8c0e2a2cb209c06d4b6ea3b444649.png";